var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-layout" }, [
    _c(
      "div",
      {
        staticClass: "page__header sticky-section py-6",
        class: { "page__header--min-height": _vm.hasHeaderMinHeight },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "subtitle-1 font-weight-bold px-10 mb-2 mx-auto base-content__max-width",
          },
          [_vm._t("page__direction")],
          2
        ),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-space-between px-10 mx-auto base-content__max-width",
          },
          [
            _c(
              "div",
              { staticClass: "text-h4 font-weight-bold mr-3 forth--text" },
              [_vm._t("page__title")],
              2
            ),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "d-flex" },
                  [_vm._t("page__actions")],
                  2
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "full-width" },
      [
        _c("v-progress-linear", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { indeterminate: "" },
        }),
        _vm.serverError
          ? _c("BaseServerError", {
              attrs: { goBackLink: _vm.goBackLink, backText: _vm.backText },
            })
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.serverError,
                expression: "!serverError",
              },
            ],
            staticClass: "mx-auto base-content__max-width page-content",
          },
          [_vm._t("default")],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }